export const usePersistedStore = defineStore('uniweb-persisted', {
  state: () => {
    const state: {
      lastSync: Record<string, Date>,
      showMenu: Ref<boolean>,
    } = {
      lastSync: {},
      showMenu: ref(true),
    }
    return state
  },
  getters: {

  },
  actions: {
    needSync(type: string): boolean {
      // const config = useRuntimeConfig()
      const lastSync = this.lastSync[type] ? new Date(this.lastSync[type]) : undefined
      const syncInterval: number = 1000 * 60 * 30 // 30 min

      if (syncInterval === 0) {
        return false
      }

      const nextSync = new Date()
      nextSync.setTime(nextSync.getTime() - syncInterval)

      if (!lastSync || lastSync.getTime() < nextSync.getTime()) {
        return true
      }

      return false
    },
    setLastSync(type: string): void {
      this.lastSync[type] = new Date()
    },
    resetLastSync(type: string): void {
      delete this.lastSync[type]
    },
  },
  persist: true,
})
